export const ERROR_NO_COMPANY_NAME="You need to enter a company name";
export const WARNING_AVG_EMPLOYEES = "CAUTION: Annual Average Number of \
  Employees should be less than 25,000";

export const WARNING_EMPLOYEE_TO_HOUR_RATIO = "The average hours worked by \
  all employees must be less than 8760";

export const WARNING_EMPLOYEE_RATIO_TOO_LOW = "CAUTION: The average hours \
  worked by all employees should be greater than 500 if the majority of your \
  employees are full time.";

export const ERROR_CASES_DAYS_AWAY_MISMATCH_OPP = "There are cases with days \
  away from work (Form 300A Field H), but no days away from work (Form 300A \
  Field K)";

export const ERROR_CASES_DAYS_AWAY_MISMATCH = "There are days away from work \
  (Form 300A Field K), but no cases with days away from work (Form 300A Field H)";

export const ERROR_CASES_NO_DAFW_CASES_NO_DEATH = "There are no cases with \
days away from work (Form 300A Field H) and there are no deaths. \
There can't be any days away from work (Form 300A Field K)";

export const ERROR_CASES_NO_DJTR_CASES_NO_DEATH = "There are no cases with \
job transfer or restriction (Form 300A Field I) and there are no deaths. \
There can't be any days of job transfer or restriction (Form 300A Field L)";

export const ERROR_CASES_JOB_TRANSFER_MISMATCH_OPP = "There are cases with job \
  transfer or restriction (Form 300A Field I), but no days with job transfer \
  or restriction (Form 300A Field L)";

export const ERROR_CASES_JOB_TRANSFER_MISMATCH = "There are days with job \
  transfer or restriction (Form 300A Field L), but no cases reported (Form \
  300A Field H or I)";

export const ERROR_CASES_GREATER_EMP = "CAUTION: The total number of cases \
  (Form 300A Fields G-J) is higher than Annual Average Number of Employees";

export const WARNING_RATIO_DAYS_TO_CASES = "Ratio is off between the number \
  of cases with days off and the total days off.  It should be less than 70";

export const ERROR_TOTALS_NOT_EQUAL = "ERROR: The sum of Injury and Illness \
  Types (Form 300A Fields M1-M6) must equal the sum of the Number of Cases \
  (Form 300A Fields G-J)";

export const DAYS_HIGHER_THAN_CASES = "The count of Days away from work (Form \
  300A Field K) must be greater than or equal to cases with days away from \
  work (Form 300A Field H).";

export const ERROR_NO_FIRST_NAME="You need to enter a first name";
export const ERROR_NO_LAST_NAME="You need to enter a last name";
export const ERROR_NO_EMAIL="You need to enter an email address";
export const ERROR_NO_PHONE_NUMBER="You need to enter a phone number";
export const ERROR_NO_PASSWORD="You need to enter a password";
export const ERROR_PASSWORD_NO_MATCH="Passwords do not match";
export const ERROR_NO_USER_NAME="You need to enter a username";
export const ERROR_PHONE_NUMBER_NOT_CORRECT="Phone number not in correct format";
export const ERROR_PASSWORD_FORMAT="Password needs to be at least 12 characters \
  long";

export const ERROR_EIN_BADFORMAT="EIN is in wrong format";
export const ERROR_EIN_FORMAT="Your EIN Number is in an invalid format";
export const ERROR_MIN_ZIPCODE = "Zip code must contain 5 digits";
export const ERROR_MIN_ZIPCODE_ADD_ON = "Zip code add-on must contain 4 digits";
export const ERROR_ZIPCODE_WRONG_FORMAT = "Your zipcode is not valid";
export const ERROR_NAICS_WRONG_FORMAT="NAICS code is in wrong format";
export const ERROR_NOT_AUTHENTICATED="You are not an authenticated user";
export const ERROR_NOT_AUTHRORIZED="You are not an authorized user";
export const ERROR_LOGIN_SERVER="There was an issue with our login service: ";
export const ERROR_ESTABLISHMENT_SERVER="There was an issue with our \
  establishment service: ";

export const ERROR_LOGIN_NO_USERNAME="You need to provide a username \
  or password";

export const ERROR_USER_CREATION="There was an issue with our user \
  creation service";

export const ERROR_SERVER="There was an issue with our service: ";
export const ERROR_LOGIN="Could not login, did you enter an invalid username \
  or password?";

export const ERROR_FORMS="There was an issue retrieving forms, please try \
  again later";

export const ERROR_INJURY_SUMMARY_ALPHA = " must contain only numbers.";
export const ERROR_INJURY_NEGATIVE = " must be above or equal to zero.";
export const ERROR_INJURY_SUMMARY_NO_ZERO = " must be greater than zero.";
export const ERROR_USER_UPDATE = "There was an issue with our account edit \
  service";
export const ERROR_API_GENERATE = "Your token has expired";
export const ERROR_NEEDS_VALUE=" is required.";
export const ERROR_LETTER_IN_ZIPCODE = "Zip code must contain only numbers";
export const ERROR_LETTER_IN_ZIPCODE_ADD_ON = "Zip code add-on must contain \
  only numbers";

export const ERROR_NEEDS_TO_BE_A_NUMBER = "Only numbers are allowed.";
export const ERROR_USERNAME_IN_USE = "An account already exists with that user \
  name.  Please enter a new user name.";

export const ERROR_USERNAME_BEGIN_SPACE = "Username cannot begin with a space.";
export const ERROR_USERNAME_END_SPACE = "Username cannot end with a space.";
export const ERROR_USERNAME_BAD_CHARACTERS = "Username cannot contain the \
 following characters: \" \\ / : | < > * ?. ! @ # $ % ^ & ( ) , ; ~ ` = + - _ { } [ ]";

export const ERROR_EMAIL_IN_USE = "An account already exists with that email.  \
  Please enter a new email.";

export const ERROR_INVALID_EMAIL = "Email is not valid.";
export const ERROR_EMAILS_NOT_MATCHED = "Email addresses must match.";
export const ERROR_EMAIL_DOMAINS_NOT_MATCHED = "Email Domains must match.";
export const ERROR_EMAILS_MATCHED = "Email addresses must be different."

export const ERROR_EMAIL_BEGIN_SPACE = "Email cannot begin with a space.";
export const ERROR_EMAIL_END_SPACE = "Email cannot end with a space.";

export const NAICS_NOT_FOUND = "The 6 digit NAICS code you entered was not found";
export const NAICS_NOT_ENTERED = "You must enter a 6 digit NAICS code";
export const ERROR_REPEATED_ESTABLISHMENT = "An establishment with this name exists.";
export const NO_NAICS_DATA_RETURNED = "No NAICS Codes were found for the given \
  input, please try again.";

export const ERROR_CASE_DATA_NEGATIVE = " must be above or equal to zero.";
export const ERROR_CASE_DATA_ALPHA = " must contain only numbers.";

export const ERROR_CASE_DATA_INJURY_YEAR_RANGE = "Please enter a date in the current or previous year.";
export const ERROR_CASE_DATA_INVALID_YEAR = "This date must be within the last 100 years.";
export const ERROR_DOB_INVALID_YEAR_RANGE = "Date of birth must be in a past year.";
export const ERROR_HIRED_DATE_INVALID_RANGE = "Date of hire cannot be before date of birth";
export const ERROR_CASE_DATA_NO_FUTURE_DATES = "You cannot enter a future date. Please enter a valid date.";
export const ERROR_CASE_DATA_HIRE_DATE_RELATIONSHIP = "You cannot enter a date earlier than the date the employee was hired.";
export const ERROR_CASE_DATA_DATE_OF_DEATH_REQUIRED = "Since the most serious outcome was entered as death, you have to enter the date of death.";
export const ERROR_DATE_OF_DEATH_HIRE_DATE_RELATIONSHIP = "Date cannot be before the date hired or be after today's date.";
export const ERROR_DATE_OF_DEATH_INCIDENT_DATE_RELATIONSHIP = "Date cannot be before the date of injury.";
export const ERROR_CASE_DATA_IS_NOT_A_NUMBER = "That is not a number. You have to enter a valid number of days.";
export const ERROR_CASE_DATA_DAYS_LONGER_THAN_YEAR = "This must be a number between 0 and 730 days.";
export const ERROR_REPEATED_CASE_NUMBER = "A case with the same case number exists.";
export const ERROR_INVALID_CHARACHTER = " may only contain alphabetic or numeric characters.";
export const ERROR_ALPHANUMERIC_ONLY = " must be alphanumeric.";

export const ERROR_CASE_DATA_DAFW_REQUIRED = "Since the most serious outcome was entered as 'Days Away From Work', you have to enter the number of days away from work.";
export const ERROR_CASE_DATA_DJTR_REQUIRED = "Since the most serious outcome was entered as 'Job transfer or restriction', you have to enter the number of days on job transfer or restriction.";



/** WEBPACK FOOTER **
 ** ./src/constants/errorMessages.js
 **/